import { LANDING_PAGE_WIDTH, MIN_DESKTOP_THRESHOLD } from '~/core/constants'
import React, { useEffect, useState } from 'react'
import analytics, { initAnalytics } from '~/services/analytics'

import AddCoupon from './add-coupon-button'
import Addons from './addons'
import CancelButton from '../cancel-button'
import { ColumnFlexCentered } from '~/components/common/containers'
import Features from './features'
import Footer from './footer'
import Plans from './plans'
import PropTypes from 'prop-types'
import Spinner from '~/components/common/spinner'
import Title from './title'
import { getProducts } from '../../services/api'
import normalization from '../../services/normalization'
import styled from 'styled-components'
import { translate } from '~/core/translate'

const ACTIVE_PLAN_INDEX = 0
const POPULAR_PLAN_INDEX = 0

const Container = styled(ColumnFlexCentered)`
  margin: 32px auto 65px;

  @media screen and (min-width: ${MIN_DESKTOP_THRESHOLD}) {
    width: ${LANDING_PAGE_WIDTH};
  }
`

const StyledSpinner = styled(Spinner)`
  height: 325px;
`

const AllPlansPage = ({ products = [], selectPlan, showAddCoupon, showCancel }) => {
  const [plans, setPlans] = useState(products)
  const { normalizeProducts } = normalization.current

  const init = async () => {
    initAnalytics()
    analytics.trackPageView(analytics.PAGE_NAMES.GUEST_PLANS)

    if (plans.length) {
      return
    }

    const products = await getProducts()

    setPlans(normalizeProducts(products))
  }

  useEffect(() => {
    init()
  }, [])

  return (
    <Container>
      <Title />
      {plans.length
        ? <Plans
            items={plans}
            activePlan={plans[ACTIVE_PLAN_INDEX]}
            popularPlan={plans[POPULAR_PLAN_INDEX]}
            popularText={translate('start_with')}
            selectPlan={selectPlan}
          />
        : <StyledSpinner />}
      {showAddCoupon && <AddCoupon />}
      <Addons products={plans} />
      <Features />
      {showCancel && <CancelButton />}
      <Footer />
    </Container>
  )
}

AllPlansPage.propTpes = {
  selectPlan: PropTypes.func.isRequired
}

export default AllPlansPage
